<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

<div style="background-color:#f7f4ea" class="container3" style="margin-top:60px">
  <div class="row">
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div> 
  <img src="https://petcart.in/webassets/sliders/adoption.jpg" style="width:100%;">

    </div>
  </div>
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding: 20px;">
    <span style="color: #9b7544;">
We at PETCART will never sell pets. Our heart goes out to homeless cats and dogs. Every dog and cat deserves loving home and caring parents. If you want to give one of them a chance at living happily ever after, get in touch with PETCART’s adoption center. Many individuals who want to give their puppy / adult pets for adoption don’t find proper channel. With PETCART adoption center we are trying to create a platform to find a purr-fect home for pets.


    </span>

      </div>

<div class="row" style="width: 80%; padding-left: 20%;">
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <div class="card bg-secondary" style="    background-color: #f7f4ea!important;"  routerLink="/petadoption/list/2">
        <img class="card-img-top" style="width:100%;  max-height: 245px;" src="/assets/images/da.jpg" alt="Card image">

       <div class="card-footer">
          <div class="row">
            <div class="col-12 text-center">
                <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Dog</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <div class="card bg-secondary" style="    background-color: #f7f4ea!important;"  routerLink="/petadoption/list/3" >
        <img class="card-img-top" style="width:100%;  max-height: 245px;" src="/assets/images/cat-adoption.jpeg" alt="Card image">

       <div class="card-footer">
          <div class="row">
            <div class="col-12 text-center">
                <h4 style="font-style: open sans ; font-size: 20px; color: #9b7544">Cat</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  </div>
  <div class="container">

    <div class="row" style="margin-top:50px;">
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:5px">
        <button  style="background-color:#f7f4ea; color: #9b7544;     font-weight: bold; border:2px solid #9b7544;" class="btn btn-success btn-block " (click)="goToAdoptionForm()">List For Adoption</button>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:5px" *ngIf="myadoption && myadoption.length > 0">
        <button class="btn btn-success btn-block " routerLink="/manageprofile/adoption">Click Here to Manage your adoption posts!</button>
      </div>
    </div>


    <div class="row" *ngIf="myadoption && adoptiondoc && myadoption.length> 0 && adoptiondoc.length> 0">
      <div class="col-12 text-center" style="margin-top:15px;">
          <div class="card-header" style="color:#9b7544">
            <h4> You have {{adoptiondoc.length}} pending post waiting for document upload </h4>
           </div>
      </div>
      </div>
      <div class="row" *ngIf="myadoption && adoptiondoc && myadoption.length> 0 && adoptiondoc.length> 0">
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top:5px;margin-bottom:5px;width:100%">
              <div *ngFor="let data of myadoption">
                <div *ngFor="let datan of adoptiondoc">
                  <div *ngIf="data.id === datan">
                      <div class="single-widget-area popular-post-widget">
                          <div class="single-populer-post d-flex">
                              <img src="https://passport.petcart.in/images/adoption/{{data.photo}}" alt="">
                                      <div class="post-content" style="color: #9b7544">
                                      <a>
                                          <h6>{{data.pet_name}}</h6>
                                      </a>
                                      <p>{{data.created_at | slice : 0: 10 }}</p>
                                      <button class="btn btn-success btn-block" (click)=" managePost(data.id, data.adoptionstatus)">
                                        Complete Post
                                      </button>
                                      </div>
                              </div>
                        </div>
                  </div>
                </div>
              </div>
            </div>

    </div>


  </div>
</div>
